<template>
  <div class="studioadd">
		<div class="maincontent">
			<div class="selectgroup">
				<div class="mc_div avatar_field">
					<div class="mcd_content avatar_content">
						<button
							type="button"
							class="avatar_editor"
							:class="{ is_uploading: avatarUploading }"
							:disabled="avatarUploading"
							@click="handleImage"
						>
							<div class="avatar_image_wrap">
								<img
									v-if="avatarDisplayUrl"
									:src="avatarDisplayUrl"
									alt="用户头像"
									@error="handleAvatarError"
								/>
								<div class="avatar_placeholder" v-else>
									<i class="iconfont icon-tianjiatupian_huaban"></i>
								</div>
								<div class="avatar_mask">
									<van-loading v-if="avatarUploading" size="24px" color="#ffffff" />
									<i v-else class="iconfont icon-tianjiatupian_huaban"></i>
								</div>
							</div>
							<span class="avatar_tip">{{ avatarUploading ? "正在上传..." : "点击更换头像" }}</span>
						</button>
					</div>
				</div>
				<div class="mc_div">
					<div class="mcd_title">
						<span style="color: #fd3d1e">*</span>
						<span>姓名</span>
					</div>
					<div class="mcd_content">
						<input placeholder="请输入" v-model="form.real_name" />
					</div>
				</div>

				<div class="mc_div">
					<div class="mcd_title">
						<span style="color: #fd3d1e">*</span>
						<span>联系方式</span>
					</div>
					<div class="mcd_content">
						<input type="tel" placeholder="请输入" v-model="form.telphone" />
					</div>
				</div>

				<div class="sure_add" v-if="form.real_name == '' || form.telphone == ''">确认编辑</div>
				<div class="sure_add" v-else @click="sureCreate" style="background-color: #4E89FF">确认编辑</div>
			</div>
		</div>
  </div>
</template>

<script>
import until from "@/api/until.js";
import studio_api from "@/api/teaching_studio_teaching_studio_api.js";
import tool_api from "@/api/teaching_studio_tool.js";
import importedWx from "weixin-js-sdk";
import studio_login_api from "@/api/teaching_studio_no_login.js";
export default {
  name: "studioadd",
  data() {
    return {
      showDatePicker: false,
      minDate: new Date(1999, 0, 1),
      maxDate: new Date(),
      dateItem: {},
      currentTime: new Date(),
      awardsList: [],
	  wxReady: false,
	  avatarUploading: false,
	  avatarPreview: "",
	  avatarLoadError: false,
      form: {
        avatar: "",
        real_name: "",
        sex: "",
        telphone: "",
        work_unit: "",
        awards: []
      },
      allMemberList: [],
      awardJson: {
        creatTime: "",
        contentText: "",
        contentImgs: []
      }
    };
  },
	computed: {
		avatarDisplayUrl() {
			if (this.avatarLoadError) return "";
			const avatar = this.avatarPreview || this.form.avatar;
			if (!avatar) return "";
			if (this.avatarPreview || /^(data:|blob:|wxlocalresource:|weixin:)/i.test(avatar)) {
				return avatar;
			}
			const suffix = this.$root.img_small || "";
			if (!suffix || avatar.indexOf("x-oss-process=") !== -1) return avatar;
			const normalizedSuffix = avatar.indexOf("?") !== -1 && suffix.charAt(0) === "?"
				? "&" + suffix.slice(1)
				: suffix;
			return avatar + normalizedSuffix;
		}
	},
  components: {},
	created() {
		this.wxConfigPromise = null;
	},
  mounted() {
    this.getMemberInfo();
	if (this.isWechatBrowser()) {
		this.getWXConfig().catch(error => {
			console.warn("微信 JSSDK 预初始化失败，将在选择头像时重试", error);
		});
	}
    document.title = "完善个人档案";
  },
  methods: {
	// 微信 JSSDK 必须先完成签名校验，再调用 chooseImage/uploadImage。
	isWechatBrowser() {
		return /MicroMessenger/i.test(window.navigator.userAgent || "");
	},
	getWechatSDK() {
		const candidates = [importedWx, window.jWeixin, window.wx];
		const sdk = candidates.find(item => {
			return item && typeof item.config === "function" && typeof item.ready === "function";
		});
		if (!sdk) {
			throw new Error("微信 JSSDK 加载失败，请刷新页面后重试");
		}
		return sdk;
	},
	withTimeout(promise, timeout, message) {
		return new Promise((resolve, reject) => {
			const timer = window.setTimeout(() => reject(new Error(message)), timeout);
			Promise.resolve(promise).then(
				result => {
					window.clearTimeout(timer);
					resolve(result);
				},
				error => {
					window.clearTimeout(timer);
					reject(error);
				}
			);
		});
	},
	parseWXConfig(rawConfig) {
		let config = rawConfig;
		if (typeof config === "string") {
			try {
				config = JSON.parse(config);
			} catch (error) {
				throw new Error("微信 JSSDK 配置解析失败");
			}
		}
		if (!config || !(config.app_id || config.appId) || !config.timestamp || !(config.nonce_str || config.nonceStr) || !config.signature) {
			throw new Error("微信 JSSDK 配置不完整");
		}
		return config;
	},
	checkWechatUploadApis(wxSDK) {
		return new Promise((resolve, reject) => {
			if (typeof wxSDK.checkJsApi !== "function") {
				reject(new Error("当前微信版本不支持图片上传，请升级微信后重试"));
				return;
			}
			wxSDK.checkJsApi({
				jsApiList: ["chooseImage", "uploadImage"],
				success: result => {
					const support = result.checkResult || {};
					const unavailable = ["chooseImage", "uploadImage"].some(name => {
						return support[name] === false || support[name] === "false";
					});
					if (unavailable) {
						reject(new Error("当前微信版本不支持图片上传，请升级微信后重试"));
						return;
					}
					resolve(true);
				},
				fail: error => reject(new Error(this.getWechatErrorMessage(error, "微信接口校验失败")))
			});
		});
	},
	async createWXConfigPromise() {
		const url = encodeURI(window.location.href.split("#")[0]);
		const app_id = this.$root.app_id;
		const data = await this.withTimeout(
			studio_login_api.Api_nologinWechatJssdkPost({ url, app_id }),
			15000,
			"获取微信 JSSDK 配置超时"
		);
		if (!data || data.errcode != 0) {
			throw new Error((data && (data.errmsg || data.msg)) || "获取微信 JSSDK 配置失败");
		}

		const config = this.parseWXConfig(data.other);
		const wxSDK = this.getWechatSDK();
		return new Promise((resolve, reject) => {
			let settled = false;
			const finish = (error) => {
				if (settled) return;
				settled = true;
				window.clearTimeout(timer);
				if (error) reject(error);
				else resolve(true);
			};
			const timer = window.setTimeout(() => {
				finish(new Error("微信 JSSDK 初始化超时，请刷新页面后重试"));
			}, 15000);

			wxSDK.ready(() => {
				this.checkWechatUploadApis(wxSDK).then(() => {
					this.wxReady = true;
					finish();
				}).catch(finish);
			});
			wxSDK.error(error => {
				this.wxReady = false;
				finish(new Error(this.getWechatErrorMessage(error, "微信 JSSDK 签名校验失败")));
			});
			wxSDK.config({
				debug: false,
				appId: config.app_id || config.appId,
				timestamp: config.timestamp,
				nonceStr: config.nonce_str || config.nonceStr,
				signature: config.signature,
				jsApiList: ["checkJsApi", "chooseImage", "uploadImage"]
			});
		});
	},
	async getWXConfig(forceRefresh) {
		if (!this.isWechatBrowser()) {
			throw new Error("请在微信内打开此页面后更换头像");
		}
		if (this.wxReady && !forceRefresh) return true;
		if (this.wxConfigPromise && !forceRefresh) return this.wxConfigPromise;

		this.wxReady = false;
		this.wxConfigPromise = this.createWXConfigPromise();
		try {
			return await this.wxConfigPromise;
		} catch (error) {
			this.wxConfigPromise = null;
			throw error;
		}
	},
	async ensureWXConfig() {
		try {
			return await this.getWXConfig(false);
		} catch (firstError) {
			console.warn("微信 JSSDK 初始化失败，正在重新获取签名", firstError);
			return this.getWXConfig(true);
		}
	},
	chooseWechatImage() {
		return new Promise((resolve, reject) => {
			const wxSDK = this.getWechatSDK();
			if (typeof wxSDK.chooseImage !== "function") {
				reject(new Error("当前微信版本不支持选择图片，请升级微信后重试"));
				return;
			}
			wxSDK.chooseImage({
				count: 1,
				sizeType: ["compressed"],
				sourceType: ["album", "camera"],
				success: result => resolve(result.localIds && result.localIds[0]),
				cancel: () => resolve(""),
				fail: error => reject(new Error(this.getWechatErrorMessage(error, "选择图片失败")))
			});
		});
	},
	uploadWechatImage(localId) {
		return new Promise((resolve, reject) => {
			const wxSDK = this.getWechatSDK();
			if (typeof wxSDK.uploadImage !== "function") {
				reject(new Error("当前微信版本不支持图片上传，请升级微信后重试"));
				return;
			}
			wxSDK.uploadImage({
				localId,
				isShowProgressTips: 1,
				success: result => {
					if (!result.serverId) {
						reject(new Error("微信未返回图片资源 ID"));
						return;
					}
					resolve(result.serverId);
				},
				fail: error => reject(new Error(this.getWechatErrorMessage(error, "微信图片上传失败")))
			});
		});
	},
	getWechatErrorMessage(error, fallback) {
		const message = error && (error.errMsg || error.err_msg || error.message);
		if (!message) return fallback;
		if (/invalid signature/i.test(message)) return "微信签名已失效，请刷新页面后重试";
		if (/permission denied|no permission/i.test(message)) return "公众号尚未授权图片上传接口";
		return message.indexOf(":") !== -1 ? fallback + "：" + message.split(":").slice(1).join(":") : message;
	},
	async handleImage() {
		if (this.avatarUploading) return;
		if (!this.isWechatBrowser()) {
			this.$toast("请在微信内打开此页面后更换头像");
			return;
		}

		this.avatarUploading = true;
		try {
			await this.ensureWXConfig();
			const localId = await this.chooseWechatImage();
			if (!localId) return;

			this.avatarPreview = localId;
			this.avatarLoadError = false;
			this.$toast.loading({
				message: "正在上传头像...",
				forbidClick: true,
				duration: 0
			});

			const serverId = await this.uploadWechatImage(localId);
			const avatarUrl = await this.fileUpload(serverId);
			this.form.avatar = avatarUrl;
			this.avatarPreview = "";
			this.avatarLoadError = false;
			this.$toast.clear();
			this.$toast.success("头像上传成功");
		} catch (error) {
			console.error("头像上传失败", error);
			this.avatarPreview = "";
			this.$toast.clear();
			this.$toast(error.message || "头像上传失败，请重试");
		} finally {
			this.avatarUploading = false;
		}
	},
	async fileUpload(mediaId) {
		const data = await this.withTimeout(
			studio_api.Teaching_studio_apiMediaWechatUpPost({
				app_id: this.$root.app_id,
				media_id: mediaId,
				media_type: "img",
				is_cloud: false
			}),
			30000,
			"服务器保存微信图片超时"
		);
		if (!data || data.errcode != 0 || !data.other) {
			throw new Error((data && (data.errmsg || data.msg)) || "服务器保存微信图片失败");
		}
		return data.other;
	},
	handleAvatarError() {
		this.avatarLoadError = true;
	},
    // 个人信息
    async getMemberInfo() {
		let app_id = this.$root.app_id;
		this.$toast.loading({
			message: "加载中...",
			forbidClick: true,
			duration: 0
		});
		let data = await studio_api.Teaching_studio_apiMemberLogin_userGet({app_id});
		if (data.errcode == 0) {
			this.$toast.clear();
			this.allMemberList = data.other;
			this.form.avatar = data.other.avatar;
			this.form.real_name = data.other.name;
			this.form.telphone = data.other.telphone;
			this.form.user_id=data.other.user_id
		}
    },
    //完善个人档案
    async sureCreate() {
		let computer_code = until.getCookie("guid").substring(0, 6);
		this.$toast.loading({
			message: "加载中...",
			forbidClick: true,
			duration: 0
		});

		let data = await tool_api.ToolForm_saltGet({ computer_code });
		if (data.errcode == 0) {
			this.upDateAvatar(data.other);
		}
 
		
    },
    //更新头像
    async upDateAvatar(salt) {
		let app_id = this.$root.app_id;
		let computer_code = until.getCookie("guid").substring(0, 6);
		let avatar = this.form.avatar;
		let user_id = this.form.user_id;
		let data = await studio_api.Teaching_studio_apiUserUpdateAvatarPost({app_id,computer_code,avatar,salt,user_id});
		if (data.errcode == 0) {
			let dataNext = await tool_api.ToolForm_saltGet({ computer_code });
			if (dataNext.errcode == 0) {
				this.upDateName(dataNext.other);
			}
			
		}
    },
    //更新姓名
    async upDateName(salt) {
		let app_id = this.$root.app_id;
		let computer_code = until.getCookie("guid").substring(0, 6);
		let real_name = this.form.real_name;
		let user_id = this.form.user_id;
		let data = await studio_api.Teaching_studio_apiUserUpdateReal_namePost({app_id,computer_code,real_name,salt,user_id});
		if (data.errcode == 0) {
			let dataNext = await tool_api.ToolForm_saltGet({ computer_code });
			if (dataNext.errcode == 0) {
				this.upDateTel(dataNext.other);
			}
		}
    },
   
    // 更新电话
    async upDateTel(salt) {
		let app_id = this.$root.app_id;
		let computer_code = until.getCookie("guid").substring(0, 6);
		let telphone = this.form.telphone;
		let user_id = this.form.user_id;
		let data = await studio_api.Teaching_studio_apiUserUpdateTelphonePost({app_id,computer_code,telphone,salt,user_id});
		if (data.errcode == 0) {
			setTimeout(() => {
				this.$toast("更新成功");
				this.$root.isLoading = true;
				window.history.go(-1);
			}, 1000);
		}
    },
    
  }
};
</script>
<style scoped>
.studioadd {
  width: 100%;
  /* height: 100vh; */
  display: inline-block;
}

.selectgroup {
  margin-top: 60px;
}

.slectgroupTwo {
  margin-top: 60px;
  display: none;
}

.mc_div {
  width: 100%;
  display: inline-block;
  margin-top: 40px;
}

:first-child.mc_div {
  margin-top: 0;
}

.mcd_title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 26px;
  color: #666666;
}

.mcd_title span:first-child {
  margin-right: 8px;
}

.mcd_content {
  width: 100%;
  margin-top: 16px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 28px;
}

.mcd_content input {
  width: 100%;
  height: 88px;
  border: 1px solid #e6e6e6;
  background: #ffffff;
  border-radius: 8px;
  padding-left: 30px;
  box-sizing: border-box;
  font-size: 26px;
}

.mcdc_addimg {
  width: 145px;
  height: 145px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e6e6e6;
  text-align: center;
  position: relative;
  left: 40%;
}

.avatar_field {
  margin-top: 8px;
}

.avatar_content {
  justify-content: center;
}

.avatar_editor {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 18px;
  border: 0;
  background: transparent;
  color: #7c8798;
  -webkit-tap-highlight-color: transparent;
}

.avatar_editor:disabled {
  opacity: 0.78;
}

.avatar_image_wrap {
  width: 168px;
  height: 168px;
  padding: 6px;
  position: relative;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #e8edf2;
  box-shadow: 0 10px 28px rgba(31, 41, 55, 0.12);
}

.avatar_image_wrap img,
.avatar_placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.avatar_image_wrap img {
  object-fit: cover;
}

.avatar_placeholder {
  background: #f2f6ff;
  color: #8caeff;
}

.avatar_placeholder .iconfont {
  font-size: 52px;
}

.avatar_mask {
  width: 54px;
  height: 54px;
  position: absolute;
  right: 0;
  bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 5px solid #ffffff;
  border-radius: 50%;
  background: #4e89ff;
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(78, 137, 255, 0.3);
}

.avatar_mask .iconfont {
  font-size: 24px;
}

.avatar_tip {
  font-size: 24px;
  line-height: 1.4;
}

.avatar_editor:not(:disabled):active .avatar_image_wrap {
  transform: scale(0.97);
}

.avatar_image_wrap {
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.mcdc_addimg img {
  height: 100%;
  width: 100%;
}

.mcdc_addimg .iconfont {
  position: relative;
  top: 30%;
  font-size: 48px;
  color: #999999;
}

.cansure {
  background: #79ca6a;
}

.sexRadio {
  width: 100%;
  display: flex;
  font-size: 28px;
}

.sexRadio div {
  text-align: center;
  line-height: 88px;
  width: 295px;
  height: 88px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e6e6e6;
  margin-right: 40px;
  color: #999999;
}

.sex_div {
  background: #f5fff3 !important;
  border: 1px solid #79ca6a !important;
  color: #79ca6a !important;
}

.sure_add {
  /* width: 100%; */
  margin: 60px;
}

.icon-xiangyou {
  position: absolute;
  right: 10%;
}

.stepButton {
  margin-top: 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 32px;
  font-weight: 400;
  color: #ffffff;
  margin: 60px;
}

.stepButton div {
  width: 194px;
  height: 80px;
  border-radius: 16px;
  text-align: center;
  line-height: 80px;
  margin-right: 24px;
}

.contentText {
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e6e6e6;
  padding: 26px 30px;
}

.deleImg {
  height: 30px;
  width: 30px;
  background: red;
  color: #e6e6e6;
  border-radius: 50%;
  text-align: center;
  font-size: 10px;
  position: relative;
  left: 145px;
}

.awardsHistory {
  font-size: 26px;
  margin-bottom: 12px;
  color: #999999;
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  text-align: center;
}

.awardsHistory span {
  margin-right: 12px;
}

.awardsHistory img {
  height: 142px;
  width: 145px;
}

.delHistory {
  height: 20px;
  width: 20px;
  line-height: 20px;
  background-color: #999999;
  border-radius: 50%;
  padding: 8px;
  color: #ffffff;
  font-size: 5px;
}
</style>
